(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["camera-navigation"] && !Shopify.designMode) return;
  try {
    
  const chatToggler = document.querySelector('.chat-toggler');
  if (chatToggler) {
    chatToggler.addEventListener('click', function() {
      const inbox = document.querySelector('inbox-online-store-chat');
      if (inbox?.shadowRoot) {
        inbox.shadowRoot.querySelector('.chat-toggle') ? inbox.shadowRoot.querySelector('.chat-toggle').click() : inbox.shadowRoot.querySelector('.chat-app--close-button').click();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
